<template>
  <div class="row charge_calc">
    <!-- PAYE -->
    <div class="col-12">
      <b-card header="Temporary (PAYE) Rate Calculator" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
        <ValidationObserver slim>
          <form role="form">
            <div class="row">
                <ValidationProvider rules="required" v-slot="{errors, classes}" name="NI Rate Year" tag="div" class="form-group col-xl-6">
                  <label class="form-label" for="ni_rate">NI Rate Year</label>
                  <multiselect v-model="ni_rate" id="ni_rate" name="ni_rate" placeholder="" :options="ms_opts.ni_rates"
                               class="requiredField" :class="classes" label="label" track-by="value" :allow-empty="false"
                  @input="recalculate_rates"></multiselect>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
            </div>


            <div class="table-responsive">
              <table class="table table-bordered">
                <tr>
                  <th style="width: 17.5%">Margin</th>
                  <th style="width: 17.5%">Pay Rate</th>
                  <th style="width: 10%">NI</th>
                  <th style="width: 10%">Holiday</th>
                  <th style="width: 17.5%">Pension Percentage</th>
                  <th style="width: 10%">Pension</th>
                  <th style="width: 17.5%">Charge</th>
                </tr>
                <tr v-for="(rate, i) in paye">
                  <td>
                    <ValidationProvider rules="required|decimal" :name="'Margin ' + i" v-slot="{ errors, classes }">
                      <div class="input-group">
                        <div class="input-group-prepend"><span class="input-group-text">&percnt;</span></div>
                        <input type="text" v-model="rate.margin" :id="'margin_' + i" :name="'margin_' + i" class="form-input" :class="classes"
                               @input="calc_paye_charge(i)"/>
                      </div>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider rules="required|decimal" :name="'Pay Rate ' + i" v-slot="{ errors, classes }">
                      <div class="input-group">
                        <div class="input-group-prepend"><span class="input-group-text">&pound;</span></div>
                        <input type="text" v-model="rate.pay_rate" :id="'pay_rate_' + i" :name="'pay_rate_' + i" class="form-input" :class="classes"
                               @input="calc_paye_charge(i)"/>
                      </div>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </td>
                  <td>
                    {{ rate.ni | currency }}
                  </td>
                  <td>
                    {{ rate.holiday_accrual | currency }}
                  </td>
                  <td>
                    <ValidationProvider rules="required|decimal" :name="'Margin ' + i" v-slot="{ errors, classes }">
                      <div class="input-group">
                        <div class="input-group-prepend"><span class="input-group-text">&percnt;</span></div>
                        <input type="text" v-model="rate.pension_percentage" :id="'pension_percentage_' + i" :name="'pension_percentage_' + i" class="form-input" :class="classes"
                               @input="calc_paye_charge(i)"/>
                      </div>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </td>
                  <td>
                    {{ rate.pension | currency }}
                  </td>
                  <td>
                    <strong>{{ rate.charge | currency }}</strong>
                  </td>
                </tr>
              </table>
            </div>
          </form>
        </ValidationObserver>
      </b-card>
    </div>
    <!-- Contractor -->
<!--    <div class="col-xl-6">-->
<!--      <b-card header="Contractor Rate Calculator" header-tag="h4" body-class="mb-3 pb-0 record_card_body">-->
<!--      </b-card>-->
<!--    </div>-->
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { calculateRateAsObject, renderTaxYear } from 'utils/utils';

const taxYear = require('tax-year')
const today = new Date()
const next_year_today = new Date(new Date().setFullYear(new Date().getFullYear() + 1))
const calculator = taxYear()

export default {
  name: "charge_rate_calculator",
  components: {
    Multiselect
  },
  data() {
    return {
      default_holiday_accrual: parseFloat(process.env.MIX_HOLIDAY_ACCRUAL),

      ms_opts: {
        ni_rates: [
          {label: renderTaxYear(), value: parseFloat(process.env.MIX_NI)},
          {label: renderTaxYear(true), value: parseFloat(process.env.MIX_NI_NEXT_YEAR)},
        ]
      },

      ni_rate: null,

      paye: [
        {
          margin: '',
          pay_rate: '',
          ni: '',
          holiday_accrual: '',
          pension_percentage: parseFloat(process.env.MIX_PENSION_STANDARD_PERC),
          pension: '',
          charge: ''
        },
        {
          margin: '',
          pay_rate: '',
          ni: '',
          holiday_accrual: '',
          pension_percentage: parseFloat(process.env.MIX_PENSION_STANDARD_PERC),
          pension: '',
          charge: ''
        },
        {
          margin: '',
          pay_rate: '',
          ni: '',
          holiday_accrual: '',
          pension_percentage: parseFloat(process.env.MIX_PENSION_STANDARD_PERC),
          pension: '',
          charge: ''
        },
        {
          margin: '',
          pay_rate: '',
          ni: '',
          holiday_accrual: '',
          pension_percentage: parseFloat(process.env.MIX_PENSION_STANDARD_PERC),
          pension: '',
          charge: ''
        },
        {
          margin: '',
          pay_rate: '',
          ni: '',
          holiday_accrual: '',
          pension_percentage: parseFloat(process.env.MIX_PENSION_STANDARD_PERC),
          pension: '',
          charge: ''
        }
      ],

      contract: {
        margin: 0,
        pay_rate: 0
      }
    }
  },
  beforeMount() {
    // set default value for ni rate multiselect - to the current year
    this.ni_rate = this.ms_opts.ni_rates[0];
  },
  methods: {
    // re-calculate any figures within the table if the ni rate changes
    recalculate_rates() {
      // loop through paye calculator rows
      for(let i = 0; i < this.paye.length; i++) {
        // calculate new values
        this.calc_paye_charge(i)
      }
    },
    // calculate values for paye row - including final charge rate
    calc_paye_charge(rate_index) {
      let margin = parseFloat(this.paye[rate_index].margin),
          pay_rate = parseFloat(this.paye[rate_index].pay_rate),
          check = margin !== '' && pay_rate !== '';
          
      if (check) {
        const rate = calculateRateAsObject(pay_rate, 'recruitment', 'Payroll - PAYE', margin, 0.00, 0.00, this.ni_rate.value);

        // holiday
        this.paye[rate_index].holiday_accrual = rate.ha.toFixed(2);
        
        // ni
        this.paye[rate_index].ni = rate.ni.toFixed(2);

        // pension
        this.paye[rate_index].pension = rate.pension.toFixed(2);

        // charge
        this.paye[rate_index].charge = rate.charge.toFixed(2);    
      }
    }
  }
}
</script>

<style scoped lang="scss">
.charge_calc {
  .form-input {
    padding: 0 5px 0 5px;
  }

  .input-group .input-group-prepend .input-group-text {
    height:     36px;
    min-height: 36px;
  }

  .table {
    td {
      vertical-align: middle;
    }
  }
}
</style>
